import React from "react";

const FilterIcon = ({ stroke }) => {
  return (
    <svg width="40" height="45" viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="50" height="40" rx="10" fill="#ECEDF2"/>
    <path d="M35 11H15L23 20.46V27L27 29V20.46L35 11Z" stroke="#030229" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    
  );
};

export default FilterIcon;
